'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _class2, _temp2;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../../util');

var _util2 = _interopRequireDefault(_util);

var _strftime = require('strftime');

var _strftime2 = _interopRequireDefault(_strftime);

var _lodashCompat = require('lodash-compat');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

//FIXME
var basicPrefixCls = 'time-panel';
var getCls = function getCls(prefix, basic, suffix) {
  return [prefix + '-' + basic, basic].map(function (item) {
    return '' + item + suffix;
  }).join(' ');
};
var fix2Digits = function fix2Digits(s) {
  return ('0' + s).slice(-2);
};
var HOUR_VALUES = new Array(24).fill(0).map(function (item, i) {
  return fix2Digits(i);
});
var MINUTE_VALUES = new Array(60).fill(0).map(function (item, i) {
  return fix2Digits(i);
});
var SECOND_VALUES = new Array(60).fill(0).map(function (item, i) {
  return fix2Digits(i);
});

/**
 * 时间面板
 * props.value
 * props.format = '%H:%M' //'%H:%M'|'%H:%M:%S'
 * props.disabledHours = () => { return [] } //禁用的 时 数组
 * props.disabledMinutes = (hour) => { return [] } //禁用的 分钟 数组
 * props.disabledSeconds = (hour, minute) => { return [] } //禁用的 秒 数组
 * props.hideDisabledOptions = false //是否隐藏禁止的选项
 * props.onSelect
 *
 */
var TimePanel = (_temp = _class = function (_Component) {
  _inherits(TimePanel, _Component);

  function TimePanel(props) {
    _classCallCheck(this, TimePanel);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TimePanel).call(this, props));

    _this.state = {
      value: props.value || _this._initTime(props.format)
    };
    return _this;
  }

  _createClass(TimePanel, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = this.state.value;

      if (nextProps.hasOwnProperty('value')) {
        value = nextProps.value || this._initTime(nextProps.format);
      }
      this.setState({ value: value });
    }
  }, {
    key: 'render',
    value: function render() {
      //className
      var prefixCls = this.props.prefixCls;

      var panelCls = getCls(prefixCls, basicPrefixCls, '');

      return _react2.default.createElement(
        'div',
        { className: panelCls },
        this._getContent()
      );
    }
  }, {
    key: '_getContent',
    value: function _getContent() {
      var _props = this.props;
      var prefixCls = _props.prefixCls;
      var format = _props.format;
      var hideDisabledOptions = _props.hideDisabledOptions;
      var disabledHours = _props.disabledHours;
      var disabledMinutes = _props.disabledMinutes;
      var disabledSeconds = _props.disabledSeconds;
      var value = this.state.value;

      //className

      var optionsBasicCls = getCls(prefixCls, basicPrefixCls, '-time-options');
      var optionsCls = 'options';

      var valueSplit = value.split(':');
      var options = [],
          hourValue = valueSplit[0],
          minuteValue = valueSplit[1],
          secondValue = valueSplit[2];
      if (format.indexOf('%H') !== -1) {
        optionsCls += '-hour';
        options.push(_react2.default.createElement(OptionList, { key: options.length,
          data: HOUR_VALUES,
          prefixCls: prefixCls,
          hideDisabledOptions: hideDisabledOptions,
          value: hourValue,
          disabledData: (disabledHours() || []).map(fix2Digits),
          onSelect: this._selectHour.bind(this) }));
      }

      if (format.indexOf('%M') !== -1) {
        optionsCls += '-minute';
        options.push(_react2.default.createElement(OptionList, { key: options.length,
          data: MINUTE_VALUES,
          prefixCls: prefixCls,
          hideDisabledOptions: hideDisabledOptions,
          value: minuteValue,
          disabledData: (disabledMinutes(hourValue) || []).map(fix2Digits),
          onSelect: this._selectMinute.bind(this) }));
      }

      if (format.indexOf('%S') !== -1) {
        optionsCls += '-second';
        options.push(_react2.default.createElement(OptionList, { key: options.length,
          data: SECOND_VALUES,
          prefixCls: prefixCls,
          hideDisabledOptions: hideDisabledOptions,
          value: secondValue,
          disabledData: (disabledSeconds(Number(hourValue), Number(minuteValue)) || []).map(fix2Digits),
          onSelect: this._selectSecond.bind(this) }));
      }

      return _react2.default.createElement(
        'div',
        { className: optionsBasicCls + ' ' + optionsCls },
        options
      );
    }
  }, {
    key: '_selectHour',
    value: function _selectHour(h) {
      var value = this.state.value;

      value = value.replace(/^\d+?(:\d+?(?::\d+)?)?$/, h + '$1');
      this.setState({ value: value }, this._selectHandler);
    }
  }, {
    key: '_selectMinute',
    value: function _selectMinute(m) {
      var value = this.state.value;

      value = value.replace(/^(\d+?:)\d+?((?::\d+)?)$/, '$1' + m + '$2');
      this.setState({ value: value }, this._selectHandler);
    }
  }, {
    key: '_selectSecond',
    value: function _selectSecond(s) {
      var value = this.state.value;

      value = value.replace(/^(\d+?:\d+?:)\d+?$/, '$1' + s);
      this.setState({ value: value }, this._selectHandler);
    }
  }, {
    key: '_selectHandler',
    value: function _selectHandler() {
      var onSelect = this.props.onSelect;

      onSelect && onSelect(this.state.value);
    }
  }, {
    key: '_initTime',
    value: function _initTime(format) {
      var date = new Date();
      var result = [date.getHours(), date.getMinutes()];
      if (format.indexOf('%S') !== -1) {
        result.push(date.getSeconds());
      }

      return result.map(fix2Digits).join(':');
    }
  }]);

  return TimePanel;
}(_react.Component), _class.propTypes = {
  value: _propTypes2.default.string,
  prefixCls: _propTypes2.default.string,
  disabledHours: _propTypes2.default.func,
  disabledMinutes: _propTypes2.default.func,
  disabledSeconds: _propTypes2.default.func,
  hideDisabledOptions: _propTypes2.default.bool,
  onSelect: _propTypes2.default.func
}, _class.defaultProps = {
  prefixCls: 'mt',
  format: '%H:%M',
  hideDisabledOptions: false,
  disabledHours: _lodashCompat.noop,
  disabledMinutes: _lodashCompat.noop,
  disabledSeconds: _lodashCompat.noop
}, _temp);

/**
 * 简易选项列表
 * props.value //列表当前值
 * props.data //列表数据
 * props.disabledData //禁用数据
 * props.hideDisabledOptions //是否隐藏禁用数据
 * props.onSelect //选中事件派发
 *
 */

var OptionList = (_temp2 = _class2 = function (_Component2) {
  _inherits(OptionList, _Component2);

  function OptionList(props) {
    _classCallCheck(this, OptionList);

    var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(OptionList).call(this, props));

    _this2.state = {
      value: props.value || undefined
    };
    return _this2;
  }

  _createClass(OptionList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._scrollToTop();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = this.state.value;

      if (nextProps.hasOwnProperty('value')) {
        value = nextProps.value || undefined;
      }
      this.setState({ value: value }, this._scrollToTop);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props;
      var prefixCls = _props2.prefixCls;
      var data = _props2.data;
      var disabledData = _props2.disabledData;
      var hideDisabledOptions = _props2.hideDisabledOptions;

      //className

      var containerCls = getCls(prefixCls, basicPrefixCls, '-option-list');
      var optionItemCls = getCls(prefixCls, basicPrefixCls, '-option-item');

      var value = this.state.value;

      var lis = (data || []).map(function (item, i) {
        var _M$classNames;

        var isDisabled = !!(disabledData && disabledData.includes(item));
        var isSelected = item == value;
        return _react2.default.createElement(
          'li',
          { key: i, ref: function ref(j) {
              isSelected && (_this3.$selectedLi = j);
            },
            className: _util2.default.classNames(optionItemCls, (_M$classNames = {}, _defineProperty(_M$classNames, 'option-item-selected', isSelected), _defineProperty(_M$classNames, 'option-item-disabled', isDisabled), _defineProperty(_M$classNames, 'option-item-disabled-hide', isDisabled && hideDisabledOptions), _M$classNames)), onClick: !isDisabled && _this3._selectItem.bind(_this3, item) },
          item
        );
      });
      return _react2.default.createElement(
        'div',
        { className: containerCls },
        _react2.default.createElement(
          'ul',
          { ref: 'ul' },
          lis
        )
      );
    }
  }, {
    key: '_selectItem',
    value: function _selectItem(value) {
      var _this4 = this;

      this.setState({ value: value }, function () {
        _this4._scrollToTop();
        var onSelect = _this4.props.onSelect;

        onSelect(_this4.state.value);
      });
    }
  }, {
    key: '_scrollToTop',
    value: function _scrollToTop() {
      var $ul = this.refs.ul;
      this.$selectedLi && ($ul.scrollTop = this.$selectedLi.offsetTop);
    }
  }]);

  return OptionList;
}(_react.Component), _class2.defaultProps = {
  prefixCls: 'mt',
  onSelect: _lodashCompat.noop
}, _temp2);
exports.default = TimePanel;